import {task} from "./task";

// @ts-ignore
task.task = task;
// @ts-ignore
task.default = task;
export default task;
module.exports = task;
